export default __webpack_public_path__ + "static/media/sales-force-locator.d7e00f5f.svg";